// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3J0FR","label":"Radio_label__1ohUy","checkMark":"Radio_checkMark__3xnn2","disabled":"Radio_disabled__33ewC"};